
function paymentDataKey() {
  return 'payment-data'
}

function addPaymentCode(isSmall) {
  let addBtnID = "#add-payment-code";
  let selectedCodeID = '#selected-payment-code';
  let unitSellingPriceInputID = '#unit-selling-price';
  let amountID = '#code-amount'

  if (isSmall) {
    addBtnID = `${addBtnID}-sm`;
    selectedCodeID = `${selectedCodeID}-sm`;
    unitSellingPriceInputID = `${unitSellingPriceInputID}-sm`;
    amountID = `${amountID}-sm`;
  }

  $(addBtnID).click(function () {
    const selectedOption = $(`${selectedCodeID} option:selected`)
    const codeName = selectedOption.data('name');
    const codeId = selectedOption.val();
    const elementId = 'selected-payment-code-' + codeId;

    if ($("#" + elementId).length > 0) {
      toastNotification('info', codeName + ' already Added');
    } else {
      const amount = removeCommas($(amountID).val())

      if (isNaN(amount) || allWhiteSpaces(amount)) {
        toastNotification('error', 'Invalid value');
      } else {

        const paymentItem = {
          key: codeId,
          code_name: codeName,
          code_id: codeId,
          amount: amount
        }

        storeItemInLocalStorage(paymentItem, paymentDataKey())
        setPaymentDataRows()
      }
    }
  })
}

function getPaymentData(){
  const data = JSON.parse(localStorage.getItem(paymentDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return null
  }

  return data
}

function setPaymentDataRows() {
  const paymentData = JSON.parse(localStorage.getItem(paymentDataKey()))
  console.log(paymentData)

  if (paymentData === null || paymentData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".payment-voucher-codes").empty()

  // set data rows
  $.each(paymentData, function (key, codeDetails) {
    const codeName = codeDetails.code_name
    const codeId = codeDetails.code_id
    const amount = codeDetails.amount
    const elementId = codeDetails.codeId

    $(".payment-voucher-codes").append(
      `<tr>
        <td class='code' id='${elementId}'>${codeName}</td>
        <td class='code-amount text-right'>${numberWithCommas(amount)}</td>
        <td>
          <a href='javascript:;' class='remove-code' data-code-id='${codeId}'>
            <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
          </a>
        </td>
      </tr>`);
  })

  var totalAmount = calculatePaymentTotal();
  $(".payment-voucher-codes").append(
    `<tr>
        <td><strong>TOTAL</strong></td>
        <td class='total-payment text-right'>
        <strong>${numberWithCommas(totalAmount)}</strong></td><td>
        </td></tr>`)

  $('#voucher-amount').val(totalAmount);
}

function removePaymentCode() {
  $("table").on('click', '.remove-code', function () {
    const uniquekey = $(this).data('code-id')
    removeItemFromLocalStorage(uniquekey, paymentDataKey());
    setPaymentDataRows()
    toastNotification('info', 'Item removed');
  });
}



function calculatePaymentTotal() {
  const data = getPaymentData()

  if (data === null) {
    console.log('ERROR')
    return 0
  }

  let totalAmount = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.amount)
  }, 0)

  return totalAmount
}

function setInitialPaymentData() {
  localStorage.removeItem(paymentDataKey())

  const voucherId = $('#voucher-id').val()
  const action = $('#voucher-action').val()
  console.log(action)

  if (action === 'create' || voucherId === null || voucherId === undefined) {
    return
  }

  $.ajax({
    type: "get",
    url: `/vouchers/${voucherId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      localStorage.setItem(paymentDataKey(), JSON.stringify(data))
      setPaymentDataRows()
    },
    error: function (data) {
      disableSubmit()
      console.log('An error occurred.');
      console.log(data);
    },
  });

}

function submitPayment() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const paymentOptions = getPaymentOptionsStorage()
    const voucherClass = $('#payment-form').data('voucher-class')

    if (voucherClass=== 'PaymentVoucher' && (paymentOptions === null ||
      paymentOptions === undefined ||
      (Array.isArray(paymentOptions) && paymentOptions.length === 0))) {
      errorString.push('Payment option amount not set')
    }

    const paymentData = getPaymentData()

    if (paymentData === null ||
      paymentData === undefined ||
      (Array.isArray(paymentData) && paymentData.length === 0)) {
      errorString.push('Expense Codes required')
    }

    if (isEmpty($('#voucher-date').val())) {
      errorString.push('Date cannot be blank');
    }

    // if (isEmpty($('#voucher-amount-in-words').val())) {
    //   errorString.push('Amount in Words cannot be blank');
    // }

    // if (isEmpty($('#voucher-details').val())) {
    //   errorString.push('Details cannot be blank');
    // }

    if (isEmpty($('#voucher-payee').val())) {
      errorString.push('payee cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    }
    else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#payment-form').attr('action')
      const redirectUrl = postUrl
      const createdAt = $('#voucher-date').val()
      const details = $('#voucher-details').val()
      const amountInWords = $('#voucher-amount-in-words').val()
      const voucherId = $("#voucher-id").val()
      const employeeId = $("#voucher-employee-id option:selected").val()
      const payee = $("#voucher-payee").val()
      const chequeNo = $("#voucher-cheque-no").val()
      const amount = $('#voucher-amount').val()

      let action = "post"

      if ($('#voucher-action').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          voucher_code_records: paymentData,
          payment_options: paymentOptions,
          voucher: {
            voucher_id: voucherId,
            created_at: createdAt,
            employee_id: employeeId,
            payee: payee,
            cheque_no: chequeNo,
            details: details,
            amount_in_words: amountInWords,
            amount: amount
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(redirectUrl)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });

}

$(document).ready(function () {

  if ($('#payment-form').length > 0) {

    if ($('.amount-div').length > 0) {
      checkAmount('.amount', '.amount-div');
    }

    if ($('.code-amount-div').length > 0) {
      checkAmount('.code-amount', '.code-amount-div');
    }

    if ($('.code-amount-div-sm').length > 0) {
      checkAmount('.code-amount-sm', '.code-amount-div-sm');
    }
    submitPayment()
    setInitialPaymentData()
    addPaymentCode() // big screens
    addPaymentCode(true) // small screens
    removePaymentCode()
    clearFailedSubmit('#payment-form')

  }
});
